import {
    START_REGISTRATION,END_REGISTRATION,
    START_SSO_REGISTRATION,END_SSO_REGISTRATION
} from "./action";

const initState   =     {
    isProgress:false,
    error:null,
    success:null
}

export  function registerReducer(state=initState,action){
    switch(action.type){
        case START_REGISTRATION:
            return {
                ...state,
                isProgress:true,
                error:null,
                success:null
            };
        case END_REGISTRATION:
            return {
                ...state,
                isProgress:false,
                error:action.payload.error,
                success:action.payload.success
            }
        case START_SSO_REGISTRATION:
            return {
                ...state,
                isProgress:true,
                error:null,
                success:null
            };
        case END_SSO_REGISTRATION:
            return {
                ...state,
                isProgress:false,
                error:action.payload.error,
                success:action.payload.success
            }
        default:
            return state;
    }
}